const DistributionSummaryTotal = ({
    spendingAccountsTotal,
    enrollmentFeeTotal,
    teladocTotal,
    corehealthTotal,
    total
}) => {
    return (
        <div className="overflow-x-auto">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-gray-100">
                        <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Type
                        </th>
                        <th className="text-right py-3 px-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                            Amount
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                    {parseFloat(spendingAccountsTotal) > 0 && (
                        <tr className="hover:bg-gray-50 transition-colors">
                            <td className="py-3 px-2 font-medium text-gray-700">
                                Spending Accounts
                            </td>
                            <td className="py-3 px-2 text-right font-medium text-gray-900">
                                ${parseFloat(spendingAccountsTotal).toFixed(2)}
                            </td>
                        </tr>
                    )}
                    {parseFloat(enrollmentFeeTotal) > 0 && (
                        <tr className="hover:bg-gray-50 transition-colors">
                            <td className="py-3 px-2 font-medium text-gray-700">
                                Enrollment Fee
                            </td>
                            <td className="py-3 px-2 text-right font-medium text-gray-900">
                                ${parseFloat(enrollmentFeeTotal).toFixed(2)}
                            </td>
                        </tr>
                    )}
                    {parseFloat(teladocTotal) > 0 && (
                        <tr className="hover:bg-gray-50 transition-colors">
                            <td className="py-3 px-2 font-medium text-gray-700">
                                Teladoc
                            </td>
                            <td className="py-3 px-2 text-right font-medium text-gray-900">
                                ${parseFloat(teladocTotal).toFixed(2)}
                            </td>
                        </tr>
                    )}
                    {parseFloat(corehealthTotal) > 0 && (
                        <tr className="hover:bg-gray-50 transition-colors">
                            <td className="py-3 px-2 font-medium text-gray-700">
                                CoreHealth
                            </td>
                            <td className="py-3 px-2 text-right font-medium text-gray-900">
                                ${parseFloat(corehealthTotal).toFixed(2)}
                            </td>
                        </tr>
                    )}
                    <tr className="border-t border-gray-200 bg-gray-50">
                        <td className="py-3 px-2 font-semibold text-gray-900">
                            Total
                        </td>
                        <td className="py-3 px-2 text-right font-bold text-primary">
                            ${parseFloat(total).toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default DistributionSummaryTotal;
